var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pen",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.381,
    height: 43.38,
    viewBox: "0 0 43.381 43.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M244.557,199.428,217.185,226.8a10.641,10.641,0,0,1-6.485,3.058l-6.225.586a1.063,1.063,0,0,1-1.171-1.171l.586-6.225a10.642,10.642,0,0,1,3.058-6.485l27.373-27.373a7.239,7.239,0,0,1,10.238,10.238Z",
    transform: "translate(-203.297 -187.071)",
    fill: "#0e71f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M223.866,192.584l-3.774,3.752a1.54,1.54,0,0,1-1.15.477,1.609,1.609,0,0,1-1.15-.477,1.636,1.636,0,0,1,0-2.3l3.774-3.752a1.626,1.626,0,1,1,2.3,2.3Z",
    transform: "translate(-186.903 -183.87)",
    fill: "#030835"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.8110985ae99ab88405491c7c4a85555e.svg";
export { ForwardRef as ReactComponent };